import useEvent from "react-use-event-hook";
import { useRecoilState, useRecoilValue } from "recoil";

import { useGlobalEffectActions, usePageContext } from "@ryde/redux";
import {
  selectedTableDataCountSF,
  showSelectedOnlyRowsAtomFamily,
} from "@ryde/shared";

export type TUseSelectedRowsToggle = ReturnType<typeof useSelectedRowsToggle>;

export const useSelectedRowsToggle = () => {
  const { entity } = usePageContext();
  const { resetPaginationAppEvent } = useGlobalEffectActions();
  const [isActive, setIsActive] = useRecoilState(
    showSelectedOnlyRowsAtomFamily(entity),
  );
  const selectedCount = useRecoilValue(selectedTableDataCountSF(entity));

  const handleToggle = useEvent(() => {
    resetPaginationAppEvent();
    setIsActive(prev => !prev);
  });

  return {
    isActive,
    selectedCount,
    handleToggle,
  };
};
